// extracted by mini-css-extract-plugin
module.exports = {"back_container":"GoBack-module__back_container___1gW6u"};